import {Injectable} from "@angular/core";
import {ThingProvider} from "@providers/thing.provider";
import {ParkService} from "@core/park/park.service";
import {ThingData} from "@core/thing/thingData";
import {WorldsKingdomsLands} from "@core/park/worldsKingdomsLands";
import {ParkUtil} from "../../util/park";
import {ThingsUtil} from "../../util/things";
import {RefreshEvent} from "@events/RefreshEvent";
import {ResultsThings} from "@core/thing/thingConfig";
import {ThingsResult} from "@providers/thing.provider"

@Injectable()
export class ThingService {
  thingDataPartialPromise: Promise<ThingData>;


  constructor(private thing: ThingProvider, private parkService: ParkService, private parkUtil: ParkUtil,
              private thingsUtil: ThingsUtil,
              private refresher: RefreshEvent) {
    this.refresher.on().subscribe(data => {
      if (data == "thingsList.refresh" || data == "thingsDetails.refresh") {
        this.reloadThingDataLazy();
      }
    });
  }

  async processThing(thing) {

    let names = await this.parkService.getNamesByArea({
      areaId: thing.area
    });

    if (! this.thingsUtil.isResource(thing) && ! thing.thresholdConfig) {
      let area = await this.parkService.getAreaById(thing.area);
      if(area===undefined)
      {
       console.log(thing);
      }

      let threshold = this.thingsUtil.isRestroom(thing) || this.thingsUtil.isTimeBasedTask(thing) ? area.taskConfig && area.taskConfig.minutesToAssignNextTask : area.taskConfig && area.taskConfig.highThreshold;

      thing.thresholdConfig = [{
        start: "06:00",
        end: "30:00",
        threshold: threshold
      }];
    }

      thing.worldName = names.world;
      thing.kingdomName = names.kingdom;
      thing.areaName = names.area;

    return thing;
  }

  async getThing(thingId) {
    let thing = await this.thing.getThing(thingId);

    return await this.processThing(thing);
  }

  async getThings(options: any = {}) {
    let things: ThingsResult = await this.thing.getThings(options);
    let thingResult=things.results

    let pArray = thingResult.map(async thing => {
         return await this.processThing(thing).then((data) => { return data; });
       });
       things.results = await Promise.all(pArray);
    return things;
  }

  async getThingsGroupedByKingdom(options: any = {}) {
    let things: ThingsResult = await this.getThings(options);
    let worldsKingdomsLands: WorldsKingdomsLands = await this.parkService.getWorldsKingdomsLands();

    let groupedThings = {};

    things.results.map(thing => {
      let kingdomId = this.parkUtil.getKingdomId(thing.area);
      if (! groupedThings[kingdomId]) {
        groupedThings[kingdomId] = [];
      }

      groupedThings[kingdomId].push(thing);
    });

    return groupedThings;
  }

  async getThingsDataPartial(): Promise<ThingData> {
    if (this.thingDataPartialPromise) {
      return this.thingDataPartialPromise;
    } else {
      return this.thingDataPartialPromise = this.buildThingData();
    }
  }

  async buildThingData(): Promise<ThingData> {
    let data = new ThingData();
    let things: ThingsResult
    things = await this.thing.getThings({representation: 'partial'});
    data.things = things.results;

    data.things.forEach(thing => {
      let list = data.areaMapList.get(thing.area);
      if (!list) {
        data.areaMapList.set(thing.area, []);
        list = data.areaMapList.get(thing.area);
      }
      list.push(thing);
    });

    return data;
  }

  async reloadThingData(): Promise<ThingData> {
    return this.thingDataPartialPromise = this.buildThingData();
  }

  async getThingsByArea(areaId): Promise<Array<any>> {
    let thingData: ThingData = await this.getThingsDataPartial();
    return thingData.areaMapList.get(areaId);
  }

  reloadThingDataLazy(){
    this.thingDataPartialPromise = undefined;
  }

  getThingDefaults(thingType:string): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      let thing = {
        deploymentThreshold: this.thingsUtil.getDefaultThreshold(thingType)
      }

      resolve(thing);
    });

    return promise;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/thing/thing.service.ts